var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 816,
    height: 1768,
    viewBox: "0 0 816 1768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1150.92,
    cy: 800.319,
    r: 577.327,
    transform: "rotate(-22.1511 1150.92 800.319)",
    stroke: "url(#paint0_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1089.67,
    cy: 870.105,
    r: 535.793,
    transform: "rotate(-22.1511 1089.67 870.105)",
    stroke: "url(#paint1_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1028.35,
    cy: 939.906,
    r: 494.258,
    transform: "rotate(-22.1511 1028.35 939.906)",
    stroke: "url(#paint2_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 967.094,
    cy: 1009.69,
    r: 452.724,
    transform: "rotate(-22.1511 967.094 1009.69)",
    stroke: "url(#paint3_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.785,
    cy: 1079.49,
    r: 411.19,
    transform: "rotate(-22.1511 905.785 1079.49)",
    stroke: "url(#paint4_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 844.539,
    cy: 1149.28,
    r: 369.655,
    transform: "rotate(-22.1511 844.539 1149.28)",
    stroke: "url(#paint5_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.285,
    cy: 1219.05,
    r: 328.121,
    transform: "rotate(-22.1511 783.285 1219.05)",
    stroke: "url(#paint6_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 721.968,
    cy: 1288.85,
    r: 286.587,
    transform: "rotate(-22.1511 721.968 1288.85)",
    stroke: "url(#paint7_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.502,
    cy: 1366.47,
    r: 245.052,
    transform: "rotate(-22.1511 641.502 1366.47)",
    stroke: "url(#paint8_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.17,
    cy: 1436.26,
    r: 203.518,
    transform: "rotate(-22.1511 580.17 1436.26)",
    stroke: "url(#paint9_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.705,
    cy: 1513.88,
    r: 161.984,
    transform: "rotate(-22.1511 499.705 1513.88)",
    stroke: "url(#paint10_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.38,
    cy: 1583.68,
    r: 120.45,
    transform: "rotate(-22.1511 438.38 1583.68)",
    stroke: "url(#paint11_linear_2232_474)",
    strokeWidth: 8.30686
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 377.134,
    cy: 1653.46,
    r: 78.9152,
    transform: "rotate(-22.1511 377.134 1653.46)",
    stroke: "url(#paint12_linear_2232_474)",
    strokeWidth: 8.30686
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2232_474",
    x1: 1150.92,
    y1: 218.838,
    x2: 1150.92,
    y2: 1381.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2232_474",
    x1: 1089.67,
    y1: 330.158,
    x2: 1089.67,
    y2: 1410.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2232_474",
    x1: 1028.35,
    y1: 441.494,
    x2: 1028.35,
    y2: 1438.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2232_474",
    x1: 967.094,
    y1: 552.815,
    x2: 967.094,
    y2: 1466.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2232_474",
    x1: 905.785,
    y1: 664.148,
    x2: 905.785,
    y2: 1494.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2232_474",
    x1: 844.539,
    y1: 775.467,
    x2: 844.539,
    y2: 1523.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2232_474",
    x1: 783.285,
    y1: 886.777,
    x2: 783.285,
    y2: 1551.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2232_474",
    x1: 721.968,
    y1: 998.113,
    x2: 721.968,
    y2: 1579.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2232_474",
    x1: 641.502,
    y1: 1117.26,
    x2: 641.502,
    y2: 1615.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2232_474",
    x1: 580.17,
    y1: 1228.59,
    x2: 580.17,
    y2: 1643.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2232_474",
    x1: 499.705,
    y1: 1347.74,
    x2: 499.705,
    y2: 1680.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2232_474",
    x1: 438.38,
    y1: 1459.08,
    x2: 438.38,
    y2: 1708.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2232_474",
    x1: 377.134,
    y1: 1570.39,
    x2: 377.134,
    y2: 1736.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D6FE",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D6FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion2);
export default __webpack_public_path__ + "static/media/Union-2.f2a81d0a34327bab9532014d5c2bea23.svg";
export { ForwardRef as ReactComponent };